import { Navigate, Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography, Button, Divider } from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { MHidden } from '../components/@material-extend';
import UserInfo from 'src/utils/Authorization/UserInfo';
import EmpLoginForm from 'src/components/authentication/login/EmpLoginForm';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Login() {
  const userInfo = UserInfo();
  if (userInfo && userInfo?.active_role) return <Navigate to={'/dashboard'} replace />
  return (
    <RootStyle title="Employee Login | CRM">
      <AuthLayout>
        {/* Login as a Candidate ? &nbsp;
        <Link underline="none" variant="subtitle2" component={RouterLink} to="/login">
         click here
        </Link> */}
      </AuthLayout>

      <MHidden width="mdDown">
        <SectionStyle>
          <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
            {/* Hi, Welcome */}
          </Typography>
          <img src="/static/illustrations/login-illustration.png" alt="login" />
        </SectionStyle>
      </MHidden>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 5 }}>
            <Typography variant="h4" gutterBottom>
              Sign in as Employee
            </Typography>
            <Typography sx={{ color: 'text.secondary' }}>Enter your ERP credentials below.</Typography>
          </Stack>

          <EmpLoginForm />

          <Divider sx={{ my: 3 }}>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              OR
            </Typography>
          </Divider>

          <Stack spacing={1.5} alignItems="center">
            <Button
              fullWidth
              size="large"
              variant="outlined"
              component={RouterLink}
              to="/investor/login"
            >
              Investor Login
            </Button>
            <Button
              fullWidth
              size="large"
              variant="outlined"
              component={RouterLink}
              to="/founder/login"
            >
              Founder Login
            </Button>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              New investor?{' '}
              <Link variant="subtitle2" component={RouterLink} to="/investor/register">
                Register here
              </Link>
            </Typography>
          </Stack>

        </ContentStyle>
      </Container>
    </RootStyle>
  );
}